// Uploady
import { FILE_STATES } from '@rpldy/chunked-uploady'

// Interfaces
import { IProgressProps } from './interfaces'

// Antd
import { Progress as AntdProgress } from 'antd'

const Progress = ({ file }: IProgressProps) => {
  return (
    <AntdProgress
      percent={
        [FILE_STATES.ERROR, FILE_STATES.ABORTED].includes(file.state)
          ? 100
          : file.state === FILE_STATES.UPLOADING && file.completed === 0
          ? 100
          : parseInt(file.completed as any)
      }
      status={
        [FILE_STATES.ERROR, FILE_STATES.ABORTED].includes(file.state)
          ? 'exception'
          : file.state === FILE_STATES.FINISHED
          ? 'success'
          : file.state === FILE_STATES.UPLOADING && file.completed === 0
          ? 'active'
          : 'normal'
      }
    />
  )
}

export { Progress }
